import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormGroup, Validators } from '@angular/forms';

import Utils from 'src/app/utils';
import * as _ from 'lodash-es';
declare var require: any;

import timezones from 'timezones-list';

declare var require: any;

@Component({
  selector: 'app-monitor-add',
  templateUrl: './monitor-add.component.html',
  styleUrls: ['./monitor-add.component.scss']
})
export class MonitorAddComponent implements OnInit {


  monitor: any;
  id?: number;
  check_in_times: { value: number; name: string }[] = [];
  alert_times = Utils.getAlertTimes();

  formGroup = new FormGroup({
    name: new FormControl('',[
      Validators.required,
    ]),
    email: new FormControl('',[
      Validators.email,
      Validators.required,
    ]),
    phone: new FormControl('',[
      this.cellConditionalRequiredValidator
    ]),
    phone2: new FormControl('',[
      this.callConditionalRequiredValidator
    ]),
    country: new FormControl(null,[]),
    timezone: new FormControl(null,[]),
    use_email : new FormControl(true,[]),
    use_phone : new FormControl(true,[]),
    use_sms : new FormControl(true,[]),
    use_whatsapp: new FormControl(false,[]),
    welcome: new FormControl(true,[]),
    learning: new FormControl(this.okService.hasFeature('learning_center'),[]),
  })

  submitted = false;
  submitting = false;

  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  countryListArray  = Utils.getCountries();
  timezoneListArray = timezones;

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService) {
    this.check_in_times = Utils.getCheckinTimes(this.okService.settings?.id);
  }


  ngOnInit(): void {

    
    if(this.okService.settings.arc_on){
      this.formGroup.setControl('phone',new FormControl('',[Validators.required]))
    }

    this.formGroup.get('use_sms')?.valueChanges
    .subscribe(value => {
      this.formGroup.get('phone')?.updateValueAndValidity();
    });

    this.formGroup.get('use_phone')?.valueChanges
    .subscribe(value => {
      this.formGroup.get('phone2')?.updateValueAndValidity();
    });

    this.formGroup.get('use_whatsapp')?.valueChanges
    .subscribe(value => {
      this.formGroup.get('phone')?.updateValueAndValidity();
    });

  }

  ngAfterViewInit()	: void {
    Utils.setupPopover();
    if(this.okService.settings.fa2){
      this.formGroup.get('phone')?.setValidators(Validators.required);
    }
  }

  submitForm(){

    if(this.submitting){
      return false;
    }

    if(this.submitted){
      Object.keys(this.formGroup.controls).forEach(key => {
        this.formGroup.get(key)?.setErrors({ invalid: null });
        this.formGroup.get(key)?.updateValueAndValidity();
      });
    }

    this.submitted = true;
    if (
      this.formGroup.valid
      ) {
        let values:any = this.formGroup.value

        // Set to none admin if they use extended privacy
        if(this.okService.hasFeature('access')){
          values.admin = false;
          values.extended = false;
        }

        // Update the contact values for the monitor
        let contact = [];
        if(!!values.use_email && values.use_email!='false'){ contact.push("Email"); }
        if(!!values.use_phone && values.use_phone!='false'){ contact.push("Phonecall"); }
        if(!!values.use_sms && values.use_sms!='false'){ contact.push("Sms"); }
        if(this.okService.hasFeature('whatsapp') && !!values.use_whatsapp && values.use_whatsapp!='false'){ contact.push("WhatsApp"); }
        values.contact = contact;

        //console.log(values);

        this.submitting = true;

        this.okService.post("monitors",values)
        .subscribe({
          next: (data) => {

            this.monitor = data.body;

            //console.log("monitor",this.monitor);
            let id = this.monitor.id;
            // this.okService.setAlert("The monitor has been added","success");

            this.router.navigateByUrl("/mgmt/monitor/"+id);
          },
          error: (e) => {

            try {
              if(Array.isArray(e)){
                let self = this;
                // Use of _.forEach() method
                _.forEach(e, function(error:any) {
                  //console.log(error);
                  self.formGroup.get(error.field)?.setErrors({ invalid: error.message });
                });
              }else{
                this.okService.setAlert(e,"warning")
              }
            } finally {
              this.submitting = false;
            }

          },
          complete: () => {
            //console.info('complete');
          }
      });
      }

    return false;
  }


  cellConditionalRequiredValidator(formControl: AbstractControl){

    let cellControl: any;
    cellControl = formControl;
    if(!cellControl.parent){
      return null;
    }

    if(cellControl.parent.get('use_sms').value || cellControl.parent.get('use_whatsapp').value){
      return Validators.required(cellControl);
    }

    return null;

  }

  callConditionalRequiredValidator(formControl: AbstractControl){

    let callControl: any;
    callControl = formControl;
    if(!callControl.parent){
      return null;
    }

    if(callControl.parent.get('use_phone').value){
      return Validators.required(callControl);
    }

    return null;

  }

}
